export class ProductInfo {
  productID: string;
  productName: string;
  category: { primaryCategory: 'TV' };

  constructor(productID: string, productName: string ) {
    this.productID = productID;
    this.productName = productName;
  }

  public getProductID(): string {
    return this.productID;
  }

  public getProductName(): string {
    return this.productName;
  }
}
